import { render, staticRenderFns } from "./privacyAgreementText.vue?vue&type=template&id=6446edbf&scoped=true&"
import script from "./privacyAgreementText.vue?vue&type=script&lang=js&"
export * from "./privacyAgreementText.vue?vue&type=script&lang=js&"
import style0 from "./privacyAgreementText.vue?vue&type=style&index=0&id=6446edbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446edbf",
  null
  
)

export default component.exports